// === Script block 1 ===
var nav=document.getElementById('nav');
window.addEventListener('scroll',function(){nav.classList.toggle('scrolled',window.scrollY>50)});

var obs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){en.target.classList.add('visible');obs.unobserve(en.target)}})},{threshold:.15,rootMargin:'0px 0px -50px 0px'});
document.querySelectorAll('.fade-up,.stagger').forEach(function(el){obs.observe(el)});

var flowObs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){var delay=parseInt(en.target.getAttribute('data-delay')||0);setTimeout(function(){en.target.classList.add('visible')},delay);flowObs.unobserve(en.target)}})},{threshold:.15,rootMargin:'0px 0px -30px 0px'});
document.querySelectorAll('.flow-card').forEach(function(el){flowObs.observe(el)});

// Flow scroll navigation
function flowScrollDir(dir){
  var el=document.getElementById('flowScroll');
  if(!el)return;
  var card=el.querySelector('.flow-card');
  if(!card)return;
  var w=card.offsetWidth+parseInt(getComputedStyle(el).gap||20);
  el.scrollBy({left:dir*w,behavior:'smooth'});
}
(function(){
  var fs=document.getElementById('flowScroll');
  var lb=document.getElementById('flowScrollLeft');
  var rb=document.getElementById('flowScrollRight');
  if(!fs||!lb||!rb)return;
  function updateBtns(){
    lb.style.display=fs.scrollLeft>20?'flex':'none';
    rb.style.display=fs.scrollLeft<fs.scrollWidth-fs.clientWidth-20?'flex':'none';
  }
  fs.addEventListener('scroll',updateBtns);
  window.addEventListener('resize',updateBtns);
  setTimeout(updateBtns,500);
})();

var gObs=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){en.target.querySelectorAll('.sc-gauge-fill').forEach(function(g){var p=parseInt(g.getAttribute('data-pct')),c=2*Math.PI*20,o=c-(c*p/100);g.style.strokeDasharray=c;g.style.strokeDashoffset=c;requestAnimationFrame(function(){requestAnimationFrame(function(){g.style.strokeDashoffset=o})})});gObs.unobserve(en.target)}})},{threshold:.3});
var hc=document.getElementById('heroCard');if(hc)gObs.observe(hc);

// Donut fill animation
document.querySelectorAll('.hw-donut-fill').forEach(function(d){
  var t=parseFloat(d.getAttribute('data-target')),c=2*Math.PI*16;
  setTimeout(function(){d.style.strokeDasharray=(c*t/100)+' '+c;},500);
});

var aiEl=document.getElementById('aiTyping');
if(aiEl){var aiT=aiEl.textContent;aiEl.textContent='';var aiI=0;var aO=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){var iv=setInterval(function(){if(aiI<aiT.length){aiEl.textContent+=aiT.charAt(aiI);aiI++}else clearInterval(iv)},25);aO.unobserve(aiEl)}})},{threshold:.5});aO.observe(aiEl)}

var cw=document.getElementById('chatWindow');
if(cw){var chatTimers=[];var cO=new IntersectionObserver(function(e){e.forEach(function(en){if(en.isIntersecting){chatTimers.forEach(function(t){clearTimeout(t)});chatTimers=[];en.target.querySelectorAll('.bubble').forEach(function(b){b.classList.remove('show')});requestAnimationFrame(function(){en.target.querySelectorAll('.bubble').forEach(function(b){var d=parseInt(b.getAttribute('data-delay')||0);chatTimers.push(setTimeout(function(){b.classList.add('show')},d))})})}else{chatTimers.forEach(function(t){clearTimeout(t)});chatTimers=[];en.target.querySelectorAll('.bubble').forEach(function(b){b.classList.remove('show')})}})},{threshold:.05,rootMargin:'0px 0px -20px 0px'});cO.observe(cw)}

document.querySelectorAll('.faq-q').forEach(function(btn){btn.addEventListener('click',function(){var item=btn.parentElement,ans=item.querySelector('.faq-a'),isO=item.classList.contains('open');document.querySelectorAll('.faq-item').forEach(function(i){i.classList.remove('open');i.querySelector('.faq-a').style.maxHeight=null});if(!isO){item.classList.add('open');ans.style.maxHeight=ans.scrollHeight+'px'}})});

document.querySelectorAll('.purchase-thumb').forEach(function(thumb){thumb.addEventListener('click',function(){document.querySelectorAll('.purchase-thumb').forEach(function(t){t.classList.remove('active')});thumb.classList.add('active');var src=thumb.getAttribute('data-src');var mainImg=document.getElementById('mainImgEl');if(mainImg&&src){mainImg.style.opacity='0';setTimeout(function(){mainImg.src=src;mainImg.style.opacity='1'},200)}})});
var mainImgEl=document.getElementById('mainImgEl');if(mainImgEl)mainImgEl.style.transition='opacity .3s ease';

if(window.innerWidth>900){window.addEventListener('scroll',function(){var y=window.scrollY;var o1=document.querySelector('.hero-orb-1'),o2=document.querySelector('.hero-orb-2');if(o1)o1.style.transform='translateY('+y*0.08+'px)';if(o2)o2.style.transform='translateY('+y*-0.05+'px)';});}

// Flow scroll hint auto-hide
(function(){
  var fs=document.getElementById('flowScroll');
  var fh=document.getElementById('flowScrollHint');
  if(fs&&fh){
    fs.addEventListener('scroll',function(){
      var atEnd=fs.scrollLeft+fs.clientWidth>=fs.scrollWidth-50;
      fh.style.opacity=atEnd?'0':'1';
      fh.style.pointerEvents=atEnd?'none':'auto';
    });
  }
})();

// Problem section interactive tabs + mobile swipe
(function(){
  var tabs=document.querySelectorAll('.p-tab');
  var slides=document.querySelectorAll('.p-slide');
  var dots=document.querySelectorAll('.p-dot');
  var hint=document.getElementById('pSwipeHint');
  var visual=document.getElementById('pVisual');
  var current=0;
  var autoInterval;
  var isMobile=window.innerWidth<=900;

  function activate(idx){
    var prev=(idx-1+slides.length)%slides.length;
    var next=(idx+1)%slides.length;
    tabs.forEach(function(t,i){t.classList.toggle('active',i===idx)});
    slides.forEach(function(s,i){
      s.classList.remove('active','prev','next');
      if(i===idx)s.classList.add('active');
      else if(i===prev)s.classList.add('prev');
      else if(i===next)s.classList.add('next');
    });
    dots.forEach(function(d,i){d.classList.toggle('active',i===idx)});
    current=idx;
  }

  tabs.forEach(function(tab){
    tab.addEventListener('click',function(){
      var idx=parseInt(tab.getAttribute('data-tab'));
      activate(idx);
      clearInterval(autoInterval);
      autoInterval=setInterval(function(){activate((current+1)%slides.length)},5000);
    });
  });

  dots.forEach(function(dot){
    dot.addEventListener('click',function(){
      var idx=parseInt(dot.getAttribute('data-dot'));
      activate(idx);
      clearInterval(autoInterval);
    });
  });

  // Touch swipe on mobile
  if(visual){
    var startX=0,startY=0,moving=false;
    visual.addEventListener('touchstart',function(e){
      startX=e.touches[0].clientX;
      startY=e.touches[0].clientY;
      moving=true;
    },{passive:true});
    visual.addEventListener('touchmove',function(e){
      if(!moving)return;
      var dx=e.touches[0].clientX-startX;
      var dy=e.touches[0].clientY-startY;
      if(Math.abs(dx)>Math.abs(dy)&&Math.abs(dx)>30){
        moving=false;
        clearInterval(autoInterval);
        if(dx<0&&current<slides.length-1)activate(current+1);
        else if(dx>0&&current>0)activate(current-1);
        if(hint)hint.style.display='none';
      }
    },{passive:true});
    visual.addEventListener('touchend',function(){moving=false},{passive:true});
  }

  // Auto-rotate only on desktop
  if(!isMobile){
    autoInterval=setInterval(function(){activate((current+1)%slides.length)},5000);
  }
  window.addEventListener('resize',function(){
    var nowMobile=window.innerWidth<=900;
    if(nowMobile&&autoInterval){clearInterval(autoInterval);autoInterval=null;}
    if(!nowMobile&&!autoInterval){autoInterval=setInterval(function(){activate((current+1)%slides.length)},5000);}
  });
})();

// === Script block 2 ===
// ヘッダーの背景適応
(function(){
  const nav = document.querySelector('nav');
  if(!nav) return;
  
  // 暗い背景のセクションを特定
  const darkSections = document.querySelectorAll('section');
  
  function checkNavPosition(){
    const navRect = nav.getBoundingClientRect();
    const navCenter = navRect.top + navRect.height / 2;
    let isDark = false;
    
    darkSections.forEach(function(sec){
      const rect = sec.getBoundingClientRect();
      if(navCenter >= rect.top && navCenter <= rect.bottom){
        // ヒーローセクションは動画背景で暗いので強制
        if(sec.classList.contains('hero')){
          isDark = true;
          return;
        }
        // セクションの背景色を取得
        const bg = window.getComputedStyle(sec).backgroundColor;
        const match = bg.match(/\d+/g);
        if(match){
          const r = parseInt(match[0]);
          const g = parseInt(match[1]);
          const b = parseInt(match[2]);
          const luminance = (0.299*r + 0.587*g + 0.114*b) / 255;
          if(luminance < 0.4) isDark = true;
        }
      }
    });
    
    if(isDark){
      nav.classList.add('nav-dark');
    } else {
      nav.classList.remove('nav-dark');
    }
  }
  
  window.addEventListener('scroll', checkNavPosition);
  checkNavPosition();
})();

// === Script block 3 ===
(function(){
  var pct = document.getElementById('loaderPct');
  var loader = document.getElementById('loader');
  var page = document.getElementById('pageContent');
  var progress = 0;
  var interval = setInterval(function(){
    progress += Math.floor(Math.random() * 8) + 2;
    if(progress > 95) progress = 95;
    pct.textContent = progress;
  }, 80);

  window.addEventListener('load', function(){
    clearInterval(interval);
    var count = parseInt(pct.textContent);
    var fin = setInterval(function(){
      count += 2;
      if(count >= 100){ count = 100; clearInterval(fin); }
      pct.textContent = count;
      if(count === 100){
        setTimeout(function(){
          loader.classList.add('done');
          page.classList.add('revealed');
          var navEl = document.getElementById('nav');
          if(navEl) navEl.classList.add('nav-visible');
          var fc = document.getElementById('floatingCta');
          if(fc){fc.style.opacity='1';fc.style.pointerEvents='auto';}
        }, 300);
        setTimeout(function(){
          loader.style.display = 'none';
        }, 1500);
      }
    }, 20);
  });
})();

// === Direct-to-checkout for all CTA buttons ===
(function(){
  var VARIANT_ID = 46312139292812;
  document.addEventListener('click', function(e){
    var link = e.target.closest('a[href="#buy"]');
    if(!link) return;
    e.preventDefault();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({items:[{id: VARIANT_ID, quantity: 1}]})
    }).then(function(res){
      if(res.ok) window.location.href = '/checkout';
      else window.location.href = '/cart/' + VARIANT_ID + ':1';
    }).catch(function(){
      window.location.href = '/cart/' + VARIANT_ID + ':1';
    });
  });
})();
